import React, { useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Section } from '../types';

interface SortableItemProps {
  id: string;
  section: Section;
  isActive: boolean;
  onSelect: () => void;
  onDelete: () => void;
  onRename: (newTitle: string) => void;
}

const SortableItem: React.FC<SortableItemProps> = ({ id, section, isActive, onSelect, onDelete, onRename }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedTitle, setEditedTitle] = useState(section.title);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const handleDoubleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsEditing(true);
    setEditedTitle(section.title);
  };

  const handleBlur = () => {
    setIsEditing(false);
    if (editedTitle.trim() && editedTitle !== section.title) {
      onRename(editedTitle.trim());
    } else {
      setEditedTitle(section.title);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.currentTarget.blur();
    } else if (e.key === 'Escape') {
      setEditedTitle(section.title);
      setIsEditing(false);
    }
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`sidebar-section-item ${isActive ? 'active' : ''}`}
      onClick={onSelect}
    >
      <div className="section-drag-handle" {...attributes} {...listeners}>
        ⋮⋮
      </div>
      {isEditing ? (
        <input
          type="text"
          className="section-title-input"
          value={editedTitle}
          onChange={(e) => setEditedTitle(e.target.value)}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          onClick={(e) => e.stopPropagation()}
          autoFocus
        />
      ) : (
        <div className="section-title" onDoubleClick={handleDoubleClick}>
          {section.title}
        </div>
      )}
      <button className="section-delete-btn" onClick={(e) => { e.stopPropagation(); onDelete(); }}>
        ×
      </button>
    </div>
  );
};

export default SortableItem;
